import { makeStyles } from '@material-ui/styles';
import {
    alabaster, alto, darkBlue, royalblue,
} from '../../../constants/Colors';

export default makeStyles(() => ({
    root: {
        display: 'flex',
        borderBottom: ({ isOpen, labelLevel }) => (!isOpen && labelLevel === 1 ? `1px solid ${alto}` : 'none'),
        padding: ({ isOpen, menuLevel }) => {
            switch (menuLevel) {
                case 1:
                    return '20px';
                case 2:
                    return '0 20px 0 31px';
                case 3:
                    return '0 20px 0 42px';
                default:
                    return '';
            }
        },
        margin: ({ labelLevel }) => (labelLevel === 2 || labelLevel === 3 ? '10px 0' : ''),
        cursor: 'pointer',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderLeft: '5px solid transparent',

        '&:last-of-type': {
            borderBottom: 'none',
        },

        '&:hover': {
            borderLeft: `5px solid ${royalblue}`,
            backgroundColor: alabaster,
        },
    },
    subItems: {
        borderBottom: ({ menuLevel }) => (menuLevel === 1 ? `1px solid ${alto}` : ''),
    },
    labelWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    label: {
        fontSize: ({ labelLevel }) => {
            switch (labelLevel) {
                case 2:
                    return 19;
                case 3:
                    return 15;
                default:
                    return 18;
            }
        },
        lineHeight: 1.5,
        fontWeight: ({ labelLevel, isResellerPartner }) => {
            if (isResellerPartner) {
                return 'bold';
            }
            if (labelLevel === 3) {
                return 300;
            }
            return 600;
        },
        textTransform: ({ labelLevel }) => (labelLevel === 1 ? 'uppercase' : 'capitalized'),
        marginRight: 4,
    },
    chevron: {
        position: 'absolute',
        top: 5,
        right: '20px',
        transition: 'transform linear 150ms',
        transform: ({ isOpen }) => (isOpen ? 'rotateZ(-90deg)' : 'none'),
    },
    actionButton: {
        cursor: 'pointer',
        textTransform: 'uppercase',
        fontSize: 13,
        fontWeight: 600,
        color: royalblue,
    },
    viewMore: {
        textAlign: 'center',
        cursor: 'pointer',
        color: royalblue,
    },
}));
